var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgLifetimeOfLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.134 20.193-1.937-2e-3c-1.808 0-2.965-0.175-4.823-0.69-1.15-0.32-2.569-0.77-3.777-1.368a64.992 64.992 0 0 1 2.638-1.257c1.638-0.738 4.227-1.112 6.056-1.112h1.843a2.21 2.21 0 0 1 2.206 2.214 2.21 2.21 0 0 1-2.206 2.215m-24.426 0.044h-1.843a2.21 2.21 0 0 1-2.207-2.215c0-1.223 0.989-2.215 2.207-2.215l1.936 4e-3c2.6 0 5.725 1.084 8.264 2.262-0.923 0.446-1.89 0.896-2.912 1.336-1.813 0.78-4.51 0.829-5.445 0.829m24.345-7.162h-1.534c-1.53 0-3.68 0.424-5.155 0.816-1.93 0.512-3.972 1.518-6.303 2.692-3.174-1.843-7.672-3.506-11.49-3.506-0.335 0-1.251-4e-3 -1.625 0.051-2.665 0.39-4.875 2.198-4.875 4.902 0 2.703 2.182 4.894 4.875 4.894h1.545c3.167-2e-3 5.318-0.554 8.837-2.016 1.022-0.425 1.786-0.872 2.807-1.45 5.62 3.07 9.552 3.464 11.292 3.464 0.335 0 1.251 3e-3 1.626-0.051 2.664-0.39 4.875-2.2 4.875-4.902 0-2.703-2.183-4.894-4.875-4.894",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetimeOfLearning);
export default __webpack_public_path__ + "static/media/lifetime_of_learning.14d8c15be6f2667fcf0ec19ef540efbc.svg";
export { ForwardRef as ReactComponent };